import { styled } from '../../theme/styled'

const Fieldset = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;
  ${(p) =>
    p.disabled &&
    `
        opacity: 0.6;
        pointer-events: none;
    `}
`
export default Fieldset
